module.exports = __webpack_public_path__ + "static/media/front-side-rg.88169ff0.svg";